import React from "react";
import  { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
// Class component is used because function components don't rerender on calling refreshCells method on the grid
// Raised a github issue for clarification https://github.com/ag-grid/ag-grid-react/issues/139
const styles = theme => ({
    root: {
      padding:0,
      verticalAlign: "middle",
      height: "100%",
      color: theme.gridIconBorderColor,
      '&$checked': {
        color: theme.HeaderSelectedText
      }
    },
    checked: {
        color:theme.HeaderSelectedText
    }
  });

class CheckboxRenderer extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            checked: Boolean(this.props.value)
        }
    }

    refresh(params){
        this.setState({
            checked:Boolean(params.value)
        });
        return true;
    }

    render(){
        const { classes } = this.props;
        const { field } = this.props.colDef || {};
        return(
            <Checkbox
                checked={this.state.checked}
                onChange={(event, checked) => this.props.node.setDataValue(field,checked)}
                icon={<CheckBoxOutlineBlankIcon/>}
                checkedIcon={<CheckBoxIcon/>}
                classes={{
                    root: classes.root,
                    checked: classes.checked,
                  }}
            />
        )
    }
}

export default withStyles(styles)(CheckboxRenderer);